import { useRef, useState } from 'react';

export default function AudioPlayer({ src, title, artist }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  if (!src) return null;

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
    } else {
      audio.play().catch(() => {});
    }
  };

  return (
    <div className="flex items-center gap-3 rounded-lg bg-dark-800/70 border border-dark-700 p-3">
      <button
        type="button"
        onClick={toggle}
        className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary-600 text-white hover:bg-primary-700"
        title={playing ? 'Pausar' : 'Reproducir'}
      >
        {playing ? '❚❚' : '▶'}
      </button>
      <div className="flex-1 min-w-0">
        {title && <p className="truncate text-sm font-medium text-dark-100">{title}</p>}
        {artist && <p className="truncate text-xs text-dark-400">{artist}</p>}
        <audio
          ref={audioRef}
          src={src}
          onPlay={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
          onEnded={() => setPlaying(false)}
          className="w-full h-8 mt-1"
          controls
          preload="none"
        />
      </div>
    </div>
  );
}
